import { useEffect, useState, lazy, Suspense } from 'react';
import { useAntigravity } from '../hooks/useAntigravity';
import './AntigravityLauncher.css';

const Starfield = lazy(() => import('./Starfield'));

interface CountdownProps {
  countdown: number;
}

function CountdownOverlay({ countdown }: CountdownProps) {
  return (
    <div className="aug-overlay" data-antigravity-ignore="true">
      <div className="aug-countdown-num" key={countdown}>
        {countdown > 0 ? countdown : '🚀'}
      </div>
    </div>
  );
}

interface ResetProps {
  onReset: () => void;
}

function ResetButton({ onReset }: ResetProps) {
  return (
    <button
      className="aug-reset-btn"
      data-antigravity-ignore="true"
      onClick={onReset}
    >
      🔄 Reset
    </button>
  );
}

export default function AntigravityLauncher() {
  const { isActive, countdown, reset } = useAntigravity();
  const [showReset, setShowReset] = useState(false);

  useEffect(() => {
    if (isActive && countdown === null) {
      const timer = setTimeout(() => {
        setShowReset(true);
      }, 2000);
      return () => clearTimeout(timer);
    } else if (showReset) {
      const timer = setTimeout(() => {
        setShowReset(false);
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [isActive, countdown, showReset]);

  return (
    <>
      {isActive && countdown === null && (
        <Suspense fallback={null}>
          <Starfield />
        </Suspense>
      )}
      {countdown !== null && <CountdownOverlay countdown={countdown} />}
      {showReset && <ResetButton onReset={reset} />}
    </>
  );
}
